import { FC } from "react"
import { DefaultMoodIconSize } from "../../utils/constants"
import { MoodIconProps } from "../../utils/types"

const MoodNormalIcon: FC<MoodIconProps> = ({
  x,
  y,
  height = DefaultMoodIconSize,
  width = DefaultMoodIconSize,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      y={y}
      x={x}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.994 4.47963 15.5204 0.00597071 10 0ZM9.99935 18.3317C5.39698 18.3317 1.66602 14.6007 1.66602 9.99837C1.66602 5.396 5.39698 1.66504 9.99935 1.66504C14.6017 1.66504 18.3327 5.396 18.3327 9.99837C18.3276 14.5987 14.5996 18.3267 9.99935 18.3317ZM6.5 12.2529C6.08579 12.2529 5.75 12.5887 5.75 13.0029C5.75 13.4171 6.08579 13.7529 6.5 13.7529H13.5C13.9142 13.7529 14.25 13.4171 14.25 13.0029C14.25 12.5887 13.9142 12.2529 13.5 12.2529H6.5ZM7.08333 9.58171C7.54357 9.58171 7.91667 9.20861 7.91667 8.74837V6.24837C7.91667 5.78814 7.54357 5.41504 7.08333 5.41504C6.6231 5.41504 6.25 5.78814 6.25 6.24837V8.74837C6.25 9.20861 6.6231 9.58171 7.08333 9.58171ZM13.7507 8.74837C13.7507 9.20861 13.3776 9.58171 12.9173 9.58171C12.4571 9.58171 12.084 9.20861 12.084 8.74837V6.24837C12.084 5.78814 12.4571 5.41504 12.9173 5.41504C13.3776 5.41504 13.7507 5.78814 13.7507 6.24837V8.74837Z"
        fill="#424F80"
        fill-opacity="0.7"
      />
    </svg>
  )
}

export default MoodNormalIcon
